let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jR65k")).then(() => parcelRequire('kW5Ci'));